import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FavoritesModule } from '@shopping-angular-components/favorites';
import { UserFavoritesComponent } from './user-favorites.component';
import { SliderProModule } from '../slider-pro/slider-pro.module';
import { UserFavoriteCardComponent } from './user-favorite-card/user-favorite-card.component';
import { BaggagesWrapperModule } from '../offers/baggages-wrapper/baggages-wrapper.module';
import { TranslateModule } from '@ngx-translate/core';
import { FavoriteCardContentComponent } from './user-favorite-card/components/favorite-card-content/favorite-card-content.component';
import { FavoriteClusterComponent } from './favorite-cluster/favorite-cluster.component';
import { TextModule } from '../text/text.module';
import { FlightsCardComponent } from './user-favorite-card/flavors/flights/flights-card.component';
import { AccomodationsCardComponent } from './user-favorite-card/flavors/accommodations/accomodations-card.component';
import { FavoriteCardFlightItineraryComponent } from './user-favorite-card/flavors/flights/favorite-card-itinerary/favorite-card-itinerary.component';
import { CardHeaderComponent } from './user-favorite-card/components/header/card-header.component';
import { FlightsHeaderComponent } from './user-favorite-card/flavors/flights/flights-header/flights-header.component';
import { ActivitiesCardComponent } from './user-favorite-card/flavors/activities/activities-card.component';
import { FavoriteCardPriceboxComponent } from './user-favorite-card/components/favorite-card-pricebox/favorite-card-pricebox.component';
import { FavoriteCtaComponent } from './user-favorite-card/flavors/favoriteCta/favorite-cta.component';
import { FavImageComponent } from './user-favorite-card/components/fav-image/fav-image.component';
import { CarsCardComponent } from './user-favorite-card/flavors/cars/cars-card.component';
import { FavoriteCardDriversComponent } from './user-favorite-card/components/favorite-card-drivers/favorite-card-drivers.component';
import { TransfersCardComponent } from './user-favorite-card/flavors/transfers/transfers-card.component';
import { FavCharacteristicsIconsComponent } from './user-favorite-card/components/fav-characteristics-icons/fav-characteristics-icons.component';
import { GridModule } from "../grid/grid.module";
import { EvaButtonModule } from '../eva-button/eva-button.module';
import { EvaMessageModule } from "../eva-message/eva-message.module";
import { PriceboxModule } from '../offers/pricebox.module';



@NgModule({
  declarations: [
    UserFavoritesComponent,
    UserFavoriteCardComponent,
    FavoriteCtaComponent,
    FavoriteCardFlightItineraryComponent,
    FavoriteCardPriceboxComponent,
    FavoriteCardContentComponent,
    FavImageComponent,
    FavoriteClusterComponent,
    AccomodationsCardComponent,
    ActivitiesCardComponent,
    FlightsCardComponent,
    CardHeaderComponent,
    FlightsHeaderComponent,
    CarsCardComponent,
    FavoriteCardDriversComponent,
    TransfersCardComponent,
    FavCharacteristicsIconsComponent
  ],
  imports: [
    CommonModule,
    FavoritesModule,
    SliderProModule,
    BaggagesWrapperModule,
    TranslateModule,
    TextModule,
    GridModule,
    EvaButtonModule,
    EvaMessageModule,
    PriceboxModule
  ],
  exports: [
    UserFavoritesComponent,
    UserFavoriteCardComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class UserFavoritesModule {
}
